import React from 'react';
import { MOCK_UP } from '../../../propTypes';
import { Composition } from '../Composition';
import { wideMockUp, squareMockUp } from './config';
import './index.scss';

export const PhonesMockUp = ({ variation, className, isSquare = false }) => {
    const mockup = isSquare ? squareMockUp : wideMockUp;
    return (
        <Composition className={className}
            variation={variation}
            layers={mockup.layers}
            aspectRatio={mockup.aspectRatio}/>
    );
};

PhonesMockUp.propTypes = MOCK_UP;
